<script>
  import FilterSelectionDialog from "../../../components/filter/FilterSelectionDialog.svelte";
  import FilterSelectionButton from "../../../components/filter/FilterSelectionButton.svelte";
  import GeneralButton from "../../../components/button/GeneralButton.svelte";
  import { createSimpleOrderGanttFilters } from "./SimpleOrderGanttFilters.js";
  import { translate } from "../../../i18n/i18next.js";

  export let GanttStore
  export let onClose

  const {
    FilterableItems,
    Filters,
    RowsAllOwnedByStyle,
  } = GanttStore

  function handleFiltersChange(filter) {
    Filters.update(filters => {
      return {...filters, [filter.name]: filter}
    })
  }

  function handleClearAllFilters() {
    Filters.set(createSimpleOrderGanttFilters($RowsAllOwnedByStyle))
  }
</script>

<FilterSelectionDialog
  onClose={onClose}
>
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["AliasFilter"]}
    items={$FilterableItems["AliasFilter"]}
  />
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["OrderSeibanFilter"]}
    items={$FilterableItems["OrderSeibanFilter"]}
  />
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["OrderItemCodeFilter"]}
    items={$FilterableItems["OrderItemCodeFilter"]}
  />
  <FilterSelectionButton
    onFilterChanged={(filter) => handleFiltersChange(filter)}
    filter={$Filters["OrderItemNameFilter"]}
    items={$FilterableItems["OrderItemNameFilter"]}
  />
  <GeneralButton buttonType="secondary" buttonFunction={handleClearAllFilters}>
    {translate("frontend:filters.clearAllFilters")}
  </GeneralButton>
</FilterSelectionDialog>
